export const pathKey = (path) => (Array.isArray(path) ? path.join(">") : "");

export const pathsEqual = (a, b) => pathKey(a) === pathKey(b);

export const resolveMenuItemRule = ({ item, parentRule, routePermissions }) => {
  const allowWithoutPermission = item?.allowWithoutPermission === true;
  if (allowWithoutPermission) return { type: "allow" };

  const direct = item?.route ? routePermissions?.[item.route] : null;
  if (direct) {
    const isMulti = Array.isArray(direct) && direct.length > 0 && Array.isArray(direct[0]);
    return { type: "perm", perms: isMulti ? direct : [direct] };
  }

  if (parentRule?.type === "perm") return parentRule;

  return { type: "deny" };
};

export const canAccessByRule = ({ rule, hasPermission }) => {
  // 👑 Bypass automático si el usuario es super-su o rol 1
  if (typeof hasPermission === "function" && hasPermission(["__SUPER_USER_CHECK__"])) {
    return true;
  }
  if (!rule) return false;
  if (rule.type === "allow") return true;
  if (rule.type !== "perm") return false;
  return (rule.perms || []).some((p) => hasPermission(p));
};

export const validateMenuAgainstRoutes = ({ menu, routePermissions, ignoreRoutes = [] }) => {
  const issues = [];

  const walk = (items, parentId = "") => {
    (items || []).forEach((item) => {
      const id = parentId ? `${parentId} > ${item.id}` : item.id;
      const inferred = item?.route ? routePermissions?.[item.route] : null;

      if (item?.route && !inferred && !ignoreRoutes.includes(item.route)) {
        issues.push(`Menu item '${id}' tiene route pero no existe permiso para esa ruta.`);
      }

      if (item?.children?.length) walk(item.children, id);
    });
  };

  walk(menu);
  return issues;
};
